import { z } from 'zod';

import {
  BaseFlowBlockSchema,
  BlockType,
  ProducedType,
  RunMode,
  returnTypeSchema,
} from '../base/baseSchema.js';

export const AuthorizationSubmissionBlockConfigSchema = z.object({
  mockScenarioId: z.string().optional(),
  patientLastName: z.string().optional(),
  runMode: z.nativeEnum(RunMode).default(RunMode.Live),
});
export type AuthorizationSubmissionBlockConfig = z.infer<
  typeof AuthorizationSubmissionBlockConfigSchema
>;

export const AuthorizationSubmissionBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.AuthorizationSubmission),
  config: AuthorizationSubmissionBlockConfigSchema,
  returnType: returnTypeSchema(ProducedType.PatientOrder),
});
export type AuthorizationSubmissionBlock = z.infer<typeof AuthorizationSubmissionBlockSchema>;
